export const LOGIN_ERRORS = {
  INVALID_CREDENTIALS: "Invalid email or password",
} as const;
